

const dataSlider = [
  {
    id: 0,
    title: "",
    img: "https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776242/VishvasWebsite/Products/AutoTransformers/Slideshow%20F/jjjpllfe3ywzwwepp5on.jpg",

  },
  {
    id: 1,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776242/VishvasWebsite/Products/AutoTransformers/Slideshow%20F/yjp1gq9id86x1rdlgyti.jpg",
  },
  {
    id: 2,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776242/VishvasWebsite/Products/AutoTransformers/Slideshow%20F/sjp93rrnid0dlnqnzzt4.jpg",
  },
  {
    id: 3,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776241/VishvasWebsite/Products/AutoTransformers/Slideshow%20F/a9wgltvfhk8sgyr8qcob.jpg",
  },
  
 
];

export default dataSlider;
